import type { Action } from "svelte/action";

/**
 *
 *
 *
 *
 *
 */
export const longPressEvent: Action<HTMLElement, number> = (
  node: HTMLElement,
  threshold?: number,
) => {
  const LONG_PRESS_THRESHOLD: number = threshold ?? 500;

  const handleTouchStart = (): void => {
    const timeout = setTimeout(() => {
      node.dispatchEvent(new CustomEvent("longpress"));
    }, LONG_PRESS_THRESHOLD);

    const cancel = (): void => {
      clearTimeout(timeout);
      node.addEventListener("touchend", cancel);
      node.addEventListener("touchcancel", cancel);
    };

    node.addEventListener("touchend", cancel);
    node.addEventListener("touchcancel", cancel);
  };

  node.addEventListener("touchstart", handleTouchStart);

  return {
    destroy: () => {
      node.removeEventListener("touchstart", handleTouchStart);
    },
  };
};
